'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIBox from 'UIComponents/layout/UIBox';
const CLASSNAME = 'CodeMirror-hs-column';
export default class InputColumn extends Component {
  render() {
    const _this$props = this.props,
          {
      className,
      children
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    const cx = classNames(CLASSNAME, className);
    return /*#__PURE__*/_jsx(UIBox, Object.assign({}, props, {
      className: cx,
      children: children
    }));
  }

}
InputColumn.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};